<-- 核心产品列表页面 -->
<template>
    <div  class="w100 pos_re">
        <img src="../../static/img/index/list_bgi.png" class="w100 banner_img">
        <div class="banner">
            <div class="banner_con">
                <p class="banner_title_des">多样化▪企业化产品</p>
                <p class="banner_title">为行业<span style="color:#1088c9">赋能</span>/与伙伴<span style="color:#1088c9">共生</span></p>
                <div class="banner_cc">
                    <p>三网合一，方便快捷</p>
                    <p>安全、可靠、专业、易扩展的解决方案</p>
                    <p>满足代理商业务快速发展的不同需求，从而帮助代理商取得更优渥的回报</p>
                    <p>带来全新用户体验</p>
                </div>
                <!-- <img src="../../static/img/index/list_des.png" class="w100 banner_des_img"> -->
            </div>
        </div>
        <div class="core_content">
            <!-- <div class="left_circle">
                <img src="../../static/img/index/left_circle.png" class="animated pulse infinite">
            </div> -->
            <div class="right_circle"></div>
            <!-- <div class="des_circle"></div> -->
            <div class="des_circle1"></div>
            <div class="des_circle2"></div>
            <div class="des_circle3"></div>
            <div class="des_circle4"></div>
            <div class="core_con">
                <div class="w100 dis_column ali_cen">
                    <p class="con_title_des" style="margin-bottom:0;font-size:0.85vw">CHOICE</p>
                    <p class="con_title" style="margin:1vw 0">选择我们更专业</p>
                    <div class="dis_row ali_cen just_cen">
                        <p class="con_title_line"></p>
                        <img src="../../static/img/index/con_title_img.png" class="con_title_img">
                        <p class="con_title_line"></p>
                    </div>
                    <div class="dis_row just_bet w100 margin_top_2 flex_wrap">
                        <div class="products_item pos_re dis_row just_bet ali_cen" v-for="(item,index) in productsList" :key="index" >
                            <div class="w100 h100">
                                <img :src=item.img class="w100 h100">
                            </div>
                            <div :class="['products_item_pop dis_column just_cen ali_cen',item.productsFlag?'transform_20 bgc_00337f':'']" @click="jumpClick(item.path)" @mouseover="productsOver(index)" @mouseout="productsOut(index)" >
                                <img :src=item.icon_img style="width:4vw">
                                <p class="products_item_pop_title">{{item.title}}</p>
                                <p class="products_item_pop_line" v-show="item.productsFlag"></p>
                                <p class="products_item_pop_des" v-show="item.productsFlag">{{item.des1}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="core_bottom w100 dis_column ali_cen">
                        <div class="w100 dis_row just_bet ali_cen ">
                            <div class="core_bottom_item_left">
                                <p></p>
                                <div>
                                    <img src="../../static/img/index/video_des.png" class="w100 h100">
                                </div>
                            </div>
                            <div class="core_bottom_item_right dis_column just_cen">
                                <p class="con_title_des" style="margin-bottom:0;font-size:0.85vw">ONLINE VIDEO COMPOSITION</p>
                                <p class="con_title" style="margin:1vw 0">在线视频合成</p>
                                <p class="core_bottom_item_right_con">做企业宣传，你还在用PPT？试试企业联盟在线视频合成，轻松创作产品宣传、活动促销或员工培训视频，让你的工作事半功倍，内容引人注目。</p>
                                <p class="more" @click="jumpClick('/video_ringone')">更多细节</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="core_bottom w100 dis_column ali_cen" style="margin-top:5vw">
                    <div class="w100 dis_row just_bet ali_cen ">
                        <div class="core_bottom_item_right dis_column just_cen ali_end">
                            <p class="con_title_des" style="margin-bottom:0;font-size:0.85vw">ONLINE VIDEO COMPOSITION</p>
                            <p class="con_title" style="margin:1vw 0">铃音录制</p>
                            <p class="core_bottom_item_right_con">专业承接企业彩铃录音、广告录音制作、配音等业务，我司金牌录音师团队提供定制化服务，可发展渠道。</p>
                            <p class="more" @click="jumpClick('/ringoneRecord')">更多细节</p>
                        </div>
                            <div class="core_bottom_item_left1 dis_column ali_end">
                            <p></p>
                            <div>
                                <img src="../../static/img/index/ringone_icon.jpg" class="w100 h100">
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="w100 dis_column ali_cen" style="padding-top:10vw">
                    
                 </div>
            </div>
        </div>
    </div>
</template>

<script>
import {titleList} from '../assets/js/global.js'
export default {       
    name: 'coreProduct',
    data () {
        return {
            productsList:[{
                img:'../../static/img/index/video_ringtone.png',
                icon_img:'../../static/img/index/2-1.png',
                title:'视频彩铃',
                des1:'视频彩铃是VoLTE的特色业务，将“听的彩铃”演进成“看的彩铃”。用户在VoLTE网络下拨打语音电话或视频电话，呼叫接通前会看到一段定制视频',
                productsFlag:false,
                path:'/video_ringone'
            },{
                img:'../../static/img/index/ringone.jpg',
                icon_img:'../../static/img/index/2-2.png',
                title:'企业彩铃',
                des1:'将固定电话或手机的普通铃音替换成音乐广告的增值服务，已达到树立公司形象、对外广告宣传的目的',
                productsFlag:false,
                path:'/ringone'
            },{
                img:'../../static/img/index/video_ringtone1.png',
                icon_img:'../../static/img/index/2-4.png',
                title:'号码认证',
                des1:'通过手机号码或固话信息认证，展示真实信息，提升意向接通率',
                productsFlag:false
            },{
                img:'../../static/img/index/400.jpg',
                icon_img:'../../static/img/index/2-3.png',
                title:'400电话',
                des1:'由10位数字组成的全国唯一接入号码，专为企事业单位设计的全国范围内号码统一的虚拟电话总机',
                productsFlag:false,
                path:'/telNum'
            }],
        }
    },
    created(){
        document.documentElement.scrollTop = document.body.scrollTop = 0;
        this.$root.indexTabFlag = 1
        titleList(this.$root.indexTabList,1)
    },
    methods:{
        jumpClick(path){
            this.$message({
                message: '更多功能正在上新中，请等待....',
                type: 'warning'
            });
            // this.$router.push(path)
        },
        productsOver(index){
        this.productsList.forEach(item=>{
            item.productsFlag = false
        })
        this.productsList[index].productsFlag = true
        },
        productsOut(index){
        this.productsList[index].productsFlag = false
        }
    }
}
</script>

<style scoped>
    .banner_img{
        width: 100%;
        height: 32vw;
    }
    .banner{
        position: absolute;
        top: 3.4vw;
        left: 0;
        width: 100%;
        height: 28vw;
    }
    .banner_con{
        width: 75vw;
        height: 100%;
        margin: 0 auto;
        padding-top: 4vw;
    }
    .banner_title_des{
        width: 10vw;
        line-height: 1.8vw;
        background-color: #1088c9;
        border-radius: 6%;
        color: #fff;
        font-size: 0.8vw;
        text-align: center;
        letter-spacing: 0.15vw;
        margin-bottom: 1.5vw;
    }
    .banner_title{
        font-size: 2.3vw;
        letter-spacing: 1.4vw;
        font-weight: bold;
    }
    .banner_cc{
        margin-top: 3vw;
        font-size: 0.9vw;
        line-height: 1.8vw;
        letter-spacing: 0.2vw;
        color: #8998ab;
    }
    .banner_des_img{
        width: 8vw;
        height: 2.5vw;
        margin-top: 2vw;
    }
    .core_content{
        width: 100%;
        margin-top: 5vw;
    }
    .left_circle{
        position: absolute;
        top: 32.5vw;
        left: -5vw;
        width: 23vw;
        height: 60vw;
    }
    .right_circle{
        position: absolute;
        top: 60vw;
        right: -8vw;
        transform: translate(-50%,-50%);
        opacity: .5;
        border-radius: 50%;
        width: 10vw;
        height: 10vw;
        border: 4px solid #d1eaf3;
        background-color:  #d1eaf3;
        animation:mymove 15s infinite;
    }
    .des_circle{
        position: absolute;
        top: 70vw;
        right: 40%;
        transform: translate(-50%,-50%);
        opacity: .5;
        border-radius: 50%;
        width: 15vw;
        height: 15vw;
        border: 4px solid #d1eaf3;
        background-color:  #d1eaf3;
        animation:mymove1 25s infinite;
    }
    .des_circle2{
        position: absolute;
        top: 90vw;
        right: 0;
        animation:mymove3 25s infinite;
        transform: translate(-50%,-50%);
        opacity: .3;
        border-radius: 50%;
        width: 25vw;
        height: 25vw;
        border: 4px solid #d1eaf3;
        background-color:  #d1eaf3;
    }
    .des_circle3{
        position: absolute;
        top: 120vw;
        left: 20vw;
        animation:mymove3 25s infinite;
        transform: translate(-50%,-50%);
        opacity: .3;
        border-radius: 50%;
        width: 25vw;
        height: 25vw;
        border: 4px solid #d1eaf3;
        background-color:  #d1eaf3;
    }
    .des_circle4{
        position: absolute;
        top: 70vw;
        left: 15vw;
        animation:mymove3 25s infinite;
        transform: translate(-50%,-50%);
        opacity: .3;
        border-radius: 50%;
        width: 25vw;
        height: 25vw;
        border: 4px solid #d1eaf3;
        background-color:  #d1eaf3;
    }
    .des_circle1{
        position: absolute;
        top: 40vw;
        left: 0%;
        transform: translate(-50%,-50%);
        opacity: .5;
        border-radius: 50%;
        width: 5vw;
        height: 5vw;
        border: 4px solid #d1eaf3;
        background-color:  #d1eaf3;
        animation:mymove2 35s infinite;
    }
    .left_circle img{
        animation-duration: 20s;
    }
    .core_con{
        width: 75vw;
        margin: 0 auto;
    }
    .core_item{
        width: 25vw;
        height: 15vw;
        background: url(../../static/img/index/core_item_bgi.png) no-repeat;
        background-size: 100% 100%;
        font-size: 0.8vw;
        line-height: 1.3vw;
        letter-spacing: 0.1vw;
        color: #fff;
        padding:2vw 1.3vw;
        margin-bottom: 2vw;
        margin-right: 3vw;
        transition: all .6s;
    }
    .core_item:hover{
        -webkit-transition: all .6s;
        transition: all .6s;
        -webkit-transform: translateY(-20px);
        transform: translateY(-20px);
    }
    .core_item img{
        width: 3vw;
    }
    .core_item_title{
        font-size: 1.3vw;
        margin: 1vw 0;
    }
    .core_item_left{
        margin-top: 9vw;
    }
    .core_item_right{
        margin-top: 4vw;
    }
    .core_bottom{
        margin-top: 10vw;
    }
    .core_bottom_item_left,.core_bottom_item_right,.core_bottom_item_left1{
        width: 36vw;
        height: 22vw;
        position: relative;
    }
    .core_bottom_item_left p,.core_bottom_item_left1 p{
        width: 31vw;
        height: 19vw;
        background-color: #d0eaff;
    }
    .core_bottom_item_left div{
        position: absolute;
        right: 0;
        bottom: 0;
        width: 31vw;
        height: 19vw;
    }
    .core_bottom_item_left1 div{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 31vw;
        height: 19vw;
    }
    .core_bottom_item_right_con{
        font-size: 0.85vw;
        width: 27vw;
        color: #999999;
        line-height: 1.5vw;
        letter-spacing: 0.2vw;
    }
    .more{
        width: 6vw;
        height: 2vw;
        text-align: center;
        line-height: 2vw;
        font-size: 0.85vw;
        border: 1px solid #151616;
        color: #151616;
        margin-top: 2vw;
        transition: all .6s;
    }
    .more:hover{
        box-shadow: 0 20px 5px -10px rgba(0,0,0,.3);
        transform: translateY(10px);
        transition: all .6s;
    }
    .products_item{
    width: 18vw;
    height: 25vw;
    overflow: hidden;
  }
  .products_item_pop{
    width: 18vw;
    height: 27vw;
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,.75);
    color: #fff;
    font-size: 0.75vw;
    line-height: 1.3vw;
    transition: all .6s;
  }
  .transform_20{
    transform: translateY(-30px);
  }
  .products_item_pop_title{
    font-size: 1vw;
    margin-top:2.5vw;
    margin-bottom: 1.5vw;
  }
  .products_item_pop_line{
    width: 3vw;
    height: 0.1vw;
    background-color: #ffffff;
    margin-bottom: 1.5vw;
  }
  .products_item_pop_des{
    width: 13vw;
    text-align: center;
    height: 5vw;
  }
  .bgc_00337f{
    background-color:rgba(20, 108, 240, 0.65);
  }
  .margin_top_0{
    margin-top: 0;
  }


    /* 核心产品样式 */
  .coreproducts_item{
    width: 17.5vw;
    height: 20vw;
    box-shadow: 8px 8px 15px #efefef;
    border: 1px solid #efefef;
    transition: all .6s;
  }
  .coreproducts_con{
    height: 25vw;
  }
  .coreproducts_isactive{
    width: 22vw;
    height: 25vw;
    box-shadow: 0px 0px 32px -24px; 
    background-color: #f6f6f6;
  }
  .products_item_pop_title1{
    font-size: 1vw;
    margin-top:2vw;
    margin-bottom: 2vw;
    font-weight: bold;
  }
  .products_item_pop_des1{
    width: 13vw;
    text-align: center;
    height: 4vw;
    font-size: 0.75vw;
    color: #333333;
    line-height: 1.1vw;
  }
  .coreproducts_des_isactive{
    width: 16vw;
    font-size: 0.8vw;
    line-height: 1.4vw;
  }
  .coreproducts_item_line{
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 0.2vw;
    background-color: #55b7ff;
  }
  .coreproducts_item_img{
    position: absolute;
    height: 2.5vw;
    width: 100%;
    bottom: -1.15vw;
    left: 0;
  }
  .coreproducts_item_img img{
    width: 2.5vw;
    height: 2.5vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/CoreProduct.vue